import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import { handleAdminMedicationSendInquiry, handleAdminSupplementSendInquiry } from './actions';
import { IAdminSupplementSendInquiryState } from './slice.interface';

const initialState: IAdminSupplementSendInquiryState = {
  isLoading: false,
  isSubmitted: false,
};

export const supplementSendInquirySlice = createSlice({
  name: 'admin-supplement-send-inquiry',
  initialState,
  reducers: {
    removeAdminSupplementSendInquiry: state => {
      state.isLoading = false;
      state.isSubmitted = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleAdminSupplementSendInquiry.pending,
        (state: IAdminSupplementSendInquiryState) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleAdminSupplementSendInquiry.rejected,
        (state: IAdminSupplementSendInquiryState) => {
          state.isLoading = false;
        },
      )
      .addCase(
        handleAdminSupplementSendInquiry.fulfilled,
        (state: IAdminSupplementSendInquiryState) => {
          state.isLoading = false;
          state.isSubmitted = true;
          eventBus.emit(EventType.ADMIN_SEND_INQUIRY_SUBMITTED);
        },
      )
      .addCase(
        handleAdminMedicationSendInquiry.pending,
        (state: IAdminSupplementSendInquiryState) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleAdminMedicationSendInquiry.rejected,
        (state: IAdminSupplementSendInquiryState) => {
          state.isLoading = false;
        },
      )
      .addCase(
        handleAdminMedicationSendInquiry.fulfilled,
        (state: IAdminSupplementSendInquiryState) => {
          state.isLoading = false;
          state.isSubmitted = true;
          eventBus.emit(EventType.ADMIN_SEND_MEDICATION_INQUIRY_SUBMITTED);
        },
      );
  },
});

export const { removeAdminSupplementSendInquiry } = supplementSendInquirySlice.actions;

export default supplementSendInquirySlice.reducer;
